import { QuestionMarkCircleIcon } from '@heroicons/react/solid'
import { useCallback } from 'react'
import { savedTokens } from 'src/auth'
import CustomButton from 'src/components/Shared/UIComponents/Button'
import { getEnvString } from 'src/utils'

export default function HelpButton() {
  const [tokens] = savedTokens.useState(null)

  const onHelp = useCallback(() => {
    window.open(getEnvString('REACT_APP_HELP_URL'), '_blank')
  }, [])

  if (tokens) return null

  return (
    <CustomButton
      onClick={onHelp}
      label="Help"
      className="!border-slate-200 hover:!border-slate-300 active:!bg-slate-200 active:!border-slate-200 focus-visible:!border-theme-500 disabled:!border-slate-200 mr-2"
      icon={<QuestionMarkCircleIcon />}
      iconPosition="left"
    />
  )
}
